import { scenes } from "../scenes";
import { CustomScene } from "../models";

export default new CustomScene(
  "EndCredits",
  scenes.Introduction(),
  "audio/Main_Theme.mp3"
);
